import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useVendorsStore} from "../../store/vendors.store";

export const useVendorProductSets = () => {
    const setProductSets = useVendorsStore((state) => state.setProductSets);

    return useMutation(PartnerApi.vendorProductSets, {
        onSuccess: (data) => {
            setProductSets(data);
        },
        onError: (error) => {
            setProductSets(null);
            console.error('Login failed:', error);
        },
    });
};